import { NavLink } from "react-router-dom";
import { ROUTER_URL } from "../../constants/routerUrl";
import { useState } from "react";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { connect } from "react-redux";
import { IUserInfo } from "../../models/common/IUserProfile";

const FacultyMenu = (props: IUserInfo) => {
  const [] = useState(ROUTER_URL.FACULTY_DASHBOARD);
  const { user } = props;

  return (
    <>
      <>
        <ul className="accordion-menu">
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.FACULTY_DASHBOARD}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/dashboard.svg" alt="" /> Dashboard
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.RESOURCES}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/teacher.svg" alt="" />
              Resources{" "}
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.FACULTY_REPORTS}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/book.svg" alt="" />
              Reports
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.FACULTY_CONNECT}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/call.svg" alt="" />
              Communication
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.NOTIFICATION}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/bell.svg" alt="" />
              Notifications{" "}
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.FEEDBACK}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/feedback.svg" alt="" />
              Feedback
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.SETTINGS}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/setting.svg" alt="" />
              Settings
            </NavLink>
          </li>
          <li className="menu-item">
            <NavLink
              to={ROUTER_URL.INSTRUCTIONS}
              className={({ isActive }) =>
                isActive ? "menu-title active" : "menu-title"
              }
            >
              <img src="/assets/images/icon/help.svg" alt="" /> Help
            </NavLink>
          </li>
        </ul>
        <div className="poweredby">
          <a
            href="https://www.buduportal.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/images/budu.png" alt="" />
            Powered by Budu Portal{" "}
          </a>
          <p className="version">Version 2.0.0</p>
          <p className="copyrights">
            &copy; 2025 Budu Portal. All rights reserved.
          </p>
        </div>
      </>
    </>
  );
};
const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyMenu);
